import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { MarkdownContent } from './MarkdownContent';

interface StreamingMarkdownRendererProps {
  text: string;
  className?: string;
}

/**
 * StreamingMarkdownRenderer - Simple progressive enhancement approach.
 *
 * Always renders the accumulated text as markdown.
 * Markdown is progressively applied as text streams in.
 *
 * Trade-off: Some visual "popping" as incomplete markdown syntax completes,
 * but much simpler implementation and no dropped tokens.
 */
export const StreamingMarkdownRenderer: React.FC<
  StreamingMarkdownRendererProps
> = ({ text, className }) => (
  <MarkdownContent
    content={text}
    className={cn('@StreamingMarkdownRenderer', className)}
  />
);
